<template>
  <v-container>
    <loader-dialog :showLoader="loading" message="Carregando Funcionários..."/>
    <header-for-list-component
      sectionName="Funcionários"
      :items="activeItems"
      :totalItems="totalItems"
      :totalPages="totalPages"
      :itemsPerPage="itemsPerPage"
      :pageNumber.sync="pageNumber"
      @loadPage="loadPage($event)"
    />

    <folder-transfer-dialog
      :employee="selectedEmployee"
      ref="folderTransfer"
    />

    <v-layout align-center class="mb-4">
      <v-flex xs4>
        <v-text-field
          v-model="search"
          solo
          label="Buscar Funcionário"
          prepend-inner-icon="search"
          hide-details
          :loading="loadingSearch"
          @input="typing()"
        >
          <template v-slot:progress>
            <v-progress-linear
              v-if="loadingSearch"
              color="accent"
              indeterminate
              height="3"
            ></v-progress-linear>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex xs4></v-flex>
      <v-flex xs2>
        <v-layout align-center justify-center>
          <span class="font-weight-bold pr-2">
            Mostrar:
          </span>
          <span>
            {{status.name}}
          </span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
              >
                mdi-chevron-down
              </v-icon>
            </template>
            <v-list>
              <v-list-tile
                v-for="(item, index) in statuses"
                :key="index"
                @click="status = item;"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-btn flat color="docgo" @click.stop="newEmployee()">
          <v-icon class="pr-2">
            mdi-account-multiple-plus
          </v-icon>
          Novo Funcionário
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <v-card>
          <div v-if="activeItems.length === 0">
            <h4 style="text-align: center" class="pa-3">Nenhum funcionário encontrado com o termo buscado</h4>
          </div>

          <v-data-table
            v-else
            :headers="headers"
            :items="activeItems"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr :class="!props.item.rescission_date ? 'active' : 'inactive'" style="cursor: default">
                <td class="text-xs-left">
                  <v-layout justify-center align-center>
                    <v-avatar size="28" color="grey">
                      <v-img :src="props.item.avatar || '/static/images/settings/new-icons/user.svg'" alt="avatar"/>
                    </v-avatar>
                    <v-layout column class="pl-3" style="line-height: 1.1">
                      <span class="grey--text text--darken-2 font-weight-bold"> {{ props.item.name }} </span>
                      <span class="grey--text caption" v-if="props.item.role"> {{ props.item.role.name }} </span>
                    </v-layout>
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <span class="blue--text">{{ props.item.email }}</span>
                </td>
                <td class="text-xs-center">
                  <div class="admin-units-container">
                    <!-- Unidade principal -->
                    <v-chip
                      v-if="props.item.administrative_unit"
                      outline
                      small
                      :style="{
                        'color': `${getAdminUnitColor(props.item.administrative_unit)} !important`,
                        'border-color': `${getAdminUnitColor(props.item.administrative_unit)} !important`,
                        'background-color': 'none !important'
                      }"
                      class="mb-1 admin-unit-badge"
                    >
                      {{ props.item.administrative_unit.abbreviation || props.item.administrative_unit.name }}
                    </v-chip>

                    <!-- Unidades adicionais -->
                    <template v-if="props.item.administrative_units && props.item.administrative_units.length > 0">
                      <v-chip
                        outline
                        v-for="unit in getFilteredAdminUnits(props.item.administrative_units, props.item.administrative_unit ? props.item.administrative_unit.id : null)"
                        :key="unit.id"
                        small
                        :style="{
                          'color': `${getAdminUnitColor(unit)} !important`,
                          'border-color': `${getAdminUnitColor(unit)} !important`,
                          'background-color': 'none !important'
                        }"
                        class="mb-1 ml-1 admin-unit-badge"
                      >
                        {{ unit.abbreviation || unit.name }}
                      </v-chip>
                    </template>
                  </div>
                </td>
                <td class="text-xs-center" style="min-width: 140px">
                  <span class="grey--text">
                    {{ transformCpf(props.item.cpf) }}
                  </span>
                </td>
                <td class="text-xs-right action-icons">
                  <v-layout class="d-inline-flex">

                    <v-tooltip top v-if="!!props.item.rescission_date && props.item.items">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          class="mx-0"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon small class="mr-2" color="red">
                            mdi-alert
                          </v-icon>
                          {{ props.item.items }}
                        </v-chip>
                      </template>
                      <span>Esse usuário possui {{ props.item.items }} processos em posse</span>
                    </v-tooltip>

                    <v-btn
                      v-if="!!props.item.rescission_date"
                      icon
                      flat
                      class="mx-0"
                      @click.stop="openFolderTransferDialog(props.item)"
                    >
                      <v-icon small color="docgo">
                        mdi-call-made
                      </v-icon>
                    </v-btn>

                    <v-btn
                      icon
                      flat
                      class="mx-0"
                      @click.stop="editEmployee(props.item)"
                    >
                      <v-icon small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>
          <employee-form
           :dialog.sync="showDialogUser"
                         :roles="roles"
                         :administrativeUnits="administrativeUnits"
                         @updateList="loadPage()"/>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import EmployeeService from '@/services/system/EmployeeService';
  import HeaderForListComponent from "@/components/settings/HeaderForListComponent";
  import LoaderDialog from '@/components/LoaderDialog';
  import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';
  import RoleService from '@/services/system/RoleService';
  import FolderTransferDialog from '@/components/folder/entity/FolderTransferDialog';
  import adminUnitHandling from '@/mixins/admin-unit-handling';

  import EmployeeForm from "@/components/employees/EmployeeForm";
  import { trim } from 'lodash';
  import getColorByText from '@/assets/utils/colorByText';

  export default {
    mixins: [adminUnitHandling],
    components: {
      EmployeeForm,
      LoaderDialog,
      HeaderForListComponent,
      FolderTransferDialog,
    },
    name: "employees",
    data() {
      return {
        headers: [
          {text: 'Nome/Cargo', sortable: false, value: 'name', align: 'left'},
          {text: 'Email', sortable: false, value: 'email', align: 'center'},
          {text: 'Setor', sortable: false, value: 'administrative_unit.abbreviation', align: 'center'},
          {text: 'CPF', sortable: false, value: 'cpf', align: 'center'},
          {text: '  ', sortable: false, align: 'right'},

        ],
        activeItems: [],
        statuses: [
          {name: 'Todos', option: 'all'},
          {name: 'Ativos', option: 'active'},
          {name: 'Inativos', option: 'inactive'},
        ],
        status: {name: 'Ativos', option: 'active'},
        showDialogUser: false,
        loading: false,
        loadingSearch: false,
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 20,
        pageNumber: 1,
        search: '',
        interval: null,
        administrativeUnits: [],
        roles: [],
        selectedEmployee: {},
      };
    },
    mounted() {
      this.loadPage(1);
      this.loadAdministrativeUnits();
      this.loadRoles();
    },
    methods: {
      loadPage(pageNumber) {
        this.pageNumber = pageNumber || this.pageNumber;
        if (!this.loadingSearch) this.loading = true;

        EmployeeService.all({
          limit: this.itemsPerPage,
          page: this.pageNumber,
          q: this.search,
          status: this.status.option,
        })
          .then(({data}) => {
            this.activeItems = data.employees;
            this.totalItems = data.total;
            this.totalPages = data.total_pages;
          })
          .catch(({response}) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 6000,
              color: 'error',
              message: response.data,
              messageIcon: 'mdi-check',
            });
          })
          .finally(() => {
            this.loading = false;
            this.loadingSearch = false;
          });
      },
      getAdminUnitColor(unit) {
        if (!unit) return '#000000';
        return getColorByText(unit.abbreviation || unit.name);
      },
      typing() {
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          this.pageNumber = 1;
          this.loadPage();
        }, 500);
      },
      editEmployee(employee) {
        this.$store.dispatch('setEmployee', employee);
        this.showDialogUser = true;
      },
      newEmployee() {
        this.$store.dispatch('setEmployee', {
          address: {},
          administrative_unit: {},
          role: {},
        });
        this.showDialogUser = true;
      },
      loadAdministrativeUnits() {
        AdministrativeUnitService.all({all: true})
          .then(({ data }) => this.administrativeUnits = data);
      },
      loadRoles() {
        RoleService.all({all: true})
          .then(({ data }) => this.roles = data);
      },
      transformCpf(cpf) {
        return trim(cpf, '-').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      },
      openFolderTransferDialog(employee) {
        this.selectedEmployee = employee;
        this.$refs.folderTransfer.open();
      },
    },
    watch: {
      status(newValue) {
        this.pageNumber = 1;
        this.loadPage();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .inactive{
    & > * {
      text-decoration: line-through;
    }
  }

  .action-icons{
    text-decoration: none !important;
  }

  .admin-units-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .admin-unit-badge {
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/settings/employees/List.vue